/**
 * SphereWorkflowTransitionContent - Renders content for SphereWorkflowTransition timeline events
 * Shows from and to stage names
 */

import React from 'react';
import { useTranslation } from 'localization';
import { TimelineEvent } from 'types/timeline';

interface SphereWorkflowTransitionContentProps {
  event: TimelineEvent;
}

const SphereWorkflowTransitionContent: React.FC<SphereWorkflowTransitionContentProps> = ({ event }) => {
  const { t } = useTranslation();

  const fromStage = event.payload?.fromStageName ?? event.payload?.fromStage ?? '';
  const toStage = event.payload?.toStageName ?? event.payload?.toStage ?? '';

  return (
    <div className="sphere-timeline-event__content-block">
      <p className="sphere-timeline-event__description">
        {t('activityFeed.events.workflowTransition', {
          fromStage: String(fromStage),
          toStage: String(toStage),
        })}
      </p>
    </div>
  );
};

export default SphereWorkflowTransitionContent;
